import Vue from "vue";
const notice=new Vue();
export default notice